import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdminService } from 'src/app/services/admin/admin.service';
import { AnaliticService } from 'src/app/services/analitic/analitic.service';
import { NgChartsModule } from 'ng2-charts';
import { ChartDataset, ChartOptions, ChartType, Plugin } from 'chart.js';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-analitic',
  standalone: true,
  imports: [CommonModule, NgChartsModule],
  templateUrl: './analitic.component.html',
  styleUrl: './analitic.component.css'
})
export class AnaliticComponent {

  // აპლიკაციის იდენთიფიკატორი
  id = 0 

  // კერძის სრული რაოდენობა
  ProductCount = 0

  // დაუსრულებელი შეკვეთა
  OrderCount = 0

  topViewedLabels: string[] = [];
  topViewedData: number[] = [];

  public barChartLabels: string[] = [];
  public barChartData: ChartDataset<'bar'>[] = [
    { data: [], label: 'ნახვები' }
  ];
  public barChartOptions: ChartOptions = {
    responsive: true,
    plugins: {
      legend: { display: false },
      title: { display: true, text: 'ყველაზე ნახვადი პროდუქტები' }
    }
  };
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins: Plugin[] = [];

  constructor(
    private Analitic: AnaliticService,
    private adminService: AdminService,
    private activatedRoute: ActivatedRoute,
    
  ){

    this.activatedRoute.params.subscribe(
      params => {
        if (params['id']) {
          this.id = params['id'];
        }
      }
    );

    this.getProductCount();
    this.getOrderCount();
    this.getTopViewedProducts();
    
  }


  getOrderCount(){
    this.Analitic.getOrderCount(this.adminService.user.id.toString(), this.id.toString()).then(count => {
      this.OrderCount = count
    });
  }


  getProductCount(){
    this.Analitic.getProductCount(this.adminService.user.id.toString(), this.id.toString()).then(count => {
      this.ProductCount = count
    });
  }
  
  getTopViewedProducts() {
    this.Analitic.getTopViewedProductsLive(this.adminService.user.id.toString(), this.id.toString(), 5)
  .subscribe(data => {
    this.barChartLabels = data.map((item: any) => item.product_name?.ka_GE || 'Unnamed');
    this.barChartData = [
      { data: data.map((item: any) => item.views || 0), label: 'ნახვები' }
    ];
    console.log('🔁 Realtime data updated:', data);
  });
  }
  

  
 

}
